export default "__VITE_ASSET__FL8kfsMO__"